import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight, ArrowRight } from "lucide-react";
import { INSTAGRAM_URL } from "@/lib/site";
import { Reveal, Eyebrow } from "./Reveal";

const PHOTOS = [
  { src: "/ig/ig18.jpg", alt: "Çam ağaçlarının üzerinden zıplayan sürücü" },
  { src: "/ig/ig11.jpg", alt: "Kırmızı duvara boyanmış FX Motors logosu" },
  { src: "/ig/ig24c.jpg", alt: "Tepede enduro sürücüsü siluetinde" },
  { src: "/ig/ig04.jpg", alt: "FX kulüp alanında motosikletler ve sürücüler" },
  { src: "/ig/ig27c.jpg", alt: "Kayalık yamaçta enduro sürüşü" },
  { src: "/ig/ig14.jpg", alt: "FX garajında sıralanmış enduro motorları" },
  { src: "/ig/ig25c.jpg", alt: "Tepede üç enduro sürücüsü" },
  { src: "/ig/ig03.jpg", alt: "Bot, kask ve sürüş ekipmanları" },
];

export const Gallery = () => (
  <section id="galeri" data-testid="gallery-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
    <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <Eyebrow>Galeri</Eyebrow>
        <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Parkurdan kareler.</h2>
      </div>
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="gallery-instagram-link" className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-semibold text-white transition-colors hover:border-white">
        <Instagram className="h-5 w-5" /> @fxmotorsporlari <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </Reveal>
    <div className="columns-2 gap-3 md:columns-4 [&>*]:mb-3">
      {PHOTOS.map((p, i) => (
        <Reveal key={p.src} delay={(i % 4) * 0.06} className="break-inside-avoid">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid={`gallery-photo-${i}`} className="group block overflow-hidden border border-white/10">
            <img src={p.src} alt={p.alt} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </a>
        </Reveal>
      ))}
    </div>
    <Link to="/galeri" data-testid="gallery-all-link" className="group mt-10 inline-flex items-center gap-3 bg-brand px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">
      Tüm galeri <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
    </Link>
  </section>
);
